/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export class LoggedInUser {
  uuid: string | undefined;
  name: string | undefined;
  email: string | undefined;
  language: string | undefined;
  authType: string | undefined;
  authorities: string[] | undefined;
  companySuperAdmin: boolean | undefined;
  phoneNumberValidated = false;

  constructor(
    uuid?: string,
    name?: string,
    email?: string,
    language?: string,
    authType?: string,
    authorities?: string[],
    companySuperAdmin?: boolean
  ) {
    this.uuid = uuid;
    this.name = name;
    this.email = email;
    this.language = language;
    this.authType = authType;
    this.authorities = authorities;
    this.companySuperAdmin = companySuperAdmin;
  }
}
